import { remove } from '@/backend/api'
import type { ErrorWithMessage } from '@/backend/error'
import { errorMessages, isErrorResponse, parseError } from '@/backend/error'

import type { ApiResultNoValidationErrors } from './types'

export const deleteProfile = async (): Promise<ApiResultNoValidationErrors<void>> => {
  try {
    await remove('users/profile', {})
    return { ok: true, data: undefined }
  } catch (error) {
    if (!isErrorResponse(error)) {
      throw error
    }
    // this is guaranteed not to be a validation error
    const parsed = parseError(error, errorMessages.PROFILE_DELETE) as { error: ErrorWithMessage }
    return { error: parsed.error, ok: false }
  }
}
